import React, { useState } from "react";
import {
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import classnames from "classnames";

//images
import imagePlaceholder from "../../../assets/images/users/user-dummy-img.jpg";
import { BasicDetailsTypes } from "../../../types/profile";

interface ProfileUserProps {
  isBlocked: boolean;
  canSendFreeText: boolean;
  onCloseUserDetails: () => void;
  chatUserDetails: BasicDetailsTypes;
  onOpenVideo: () => void;
  onOpenAudio: () => void;
}

const ProfileUser = ({
  isBlocked,
  canSendFreeText,
  onCloseUserDetails,
  chatUserDetails,
  onOpenAudio,
  onOpenVideo,
}: ProfileUserProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen(!dropdownOpen);

  //Imagem do Contato
  const profile = chatUserDetails.foto1
    ? chatUserDetails.foto1
    // : chatUserDetails.avatar
    //   ? chatUserDetails.avatar
    : imagePlaceholder;

  //Nome do contato
  const fullName =
    chatUserDetails.name === undefined
      ? chatUserDetails.firstName
      : chatUserDetails.name;

  return (
    <div className="p-3 border-bottom">
      <div className="user-profile-img">
        <img src={profile} className="profile-img rounded" alt="" />
        <div className="overlay-content rounded">
          <div className="user-chat-nav p-2">
            <div className="d-flex w-100">
              <div className="flex-grow-1">
                <Button
                  color="none"
                  type="button"
                  className="btn nav-btn text-white user-profile-show d-none d-lg-block"
                  onClick={onCloseUserDetails}
                >
                  <i className="bx bx-x"></i>
                </Button>
                <Button
                  type="button"
                  color="none"
                  className="btn nav-btn text-white user-profile-show d-block d-lg-none"
                  onClick={onCloseUserDetails}
                >
                  <i className="bx bx-left-arrow-alt"></i>
                </Button>
              </div>
              <div className="flex-shrink-0">
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                  <DropdownToggle
                    color="none"
                    className="btn nav-btn text-white"
                    type="button"
                  >
                    <i className="bx bx-dots-vertical-rounded"></i>
                  </DropdownToggle>
                  <DropdownMenu className="dropdown-menu-end">
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center d-lg-none user-profile-show"
                      to="#"
                    >
                      Visualizar perfil <i className="bx bx-user text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center d-lg-none"
                      to="#"
                      onClick={onOpenAudio}
                    >
                      Audio <i className="bx bxs-phone-call text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center d-lg-none"
                      to="#"
                      onClick={onOpenVideo}
                    >
                      Video <i className="bx bx-video text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center"
                      to="#"
                    >
                      Archive <i className="bx bx-archive text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center"
                      to="#"
                    >
                      Muted <i className="bx bx-microphone-off text-muted"></i>
                    </DropdownItem>
                    <DropdownItem
                      className="d-flex justify-content-between align-items-center"
                      to="#"
                    >
                      Delete <i className="bx bx-trash text-muted"></i>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>
          <div className="mt-auto p-3">
            <h5 className="user-name mb-1 text-truncate">{fullName}</h5>
            <h5 className="user-name mb-1 text-truncate">{chatUserDetails.situacao}</h5>
            {isBlocked && chatUserDetails.blockedMessage && (
              <p className="font-size-14 text-truncate mb-0">
                <i
                  className={classnames(
                    "bx",
                    "bxs-circle",
                    "font-size-10",
                    "me-1",
                    "ms-0",
                    "text-danger",

                    // {
                    //   "text-success":
                    //     chatUserDetails.status === STATUS_TYPES.ACTIVE,
                    // },
                    // {
                    //   "text-warning":
                    //     chatUserDetails.status === STATUS_TYPES.AWAY,
                    // },
                    // {
                    //   "text-danger":
                    //     chatUserDetails.status === STATUS_TYPES.DO_NOT_DISTURB,
                    // }
                  )}
                ></i>{" "}

                <>
                  Contato bloqueado até{" "}
                  <strong>
                    {new Date(chatUserDetails.blockedMessage).toLocaleString("pt-BR")}
                  </strong>
                  <br />
                  <small>
                    {" "}Não é possível enviar mensagens/templates ou até o cliente abrir
                    uma nova janela de conversa.
                  </small>
                </>

              </p>
            )}

            {!canSendFreeText && (
              <p className="font-size-14 text-truncate mb-0">
                <>
                  ⚠️ Conversa está fora da janela de 24h.
                  <br />
                  <small>
                    {" "}É obrigatório enviar um template aprovado.
                  </small>
                </>
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileUser;
